import "./style.scss";

import Close from "@mui/icons-material/Close";
import { H1, H2, H3 } from "helpers/TypographyComponents";
import { useTranslation } from "react-i18next";
import type { ICompany } from "store/settingsStore";

import variables from "../../../../assets/styles/_variables.module.scss";

interface IEmailPreview {
    company: ICompany | undefined;
    html: string;
    onClose: () => void;
    languageTab: "fr" | "en";
}

const BeneficiaryPortalEmailPreview = ({ company, html, onClose, languageTab }: IEmailPreview) => {
    const [t] = useTranslation();

    const translations = {
        YouHaveAccess: t("PortalEmailPreview.YouHaveAccess", { lng: languageTab }),
        ThanksTo: t("PortalEmailPreview.ThanksTo", { lng: languageTab }),
        YouHaveNowAccess: t("PortalEmailPreview.YouHaveNowAccess", { lng: languageTab }),
        Activate: t("PortalEmailPreview.Activate", { lng: languageTab }),
        CodeEmail: t("PortalEmailPreview.CodeEmail", { lng: languageTab }),
        Access: t("PortalEmailPreview.Access", { lng: languageTab }),
        ThankTrust: t("PortalEmailPreview.ThankTrust", { lng: languageTab }),
        AccountCreatedWithEmail: t("PortalEmailPreview.AccountCreatedWithEmail", { lng: languageTab }),
        TemporaryPassword: t("PortalEmailPreview.TemporaryPassword", { lng: languageTab }),
        PasswordValidity: t("PortalEmailPreview.PasswordValidity", { lng: languageTab }),
    };

    const beneficiarPortalOnboardingEmail = `
    <!DOCTYPE html>
    <html lang="fr">
        <head>
            <meta charset="UTF-8" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap" rel="stylesheet">
            <title>${translations.YouHaveAccess}</title>
            <style>* { font-family: 'Poppins', sans-serif; } p { margin-top : 0; margin-bottom: 6px; } h2 { font-family: 'Poppins', sans-serif; font-size: 18px; margin-bottom: 8px;font-weight: 200; margin-top: 32px; }</style>
          <style>
            .creds {
              background: #b8aee930;
              padding: 8px 40px;
              margin-left: -40px;
              margin-right: -40px;
              margin-top: 24px;
            }
            .creds h2 {
              margin-top: 16px;
            }
          </style>
        </head>
        <body style="margin: 0; max-width: 640px;">
            <table class="email-header" role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color: #FAFAFA; font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 400; color: #646464; padding: 15px 16px 15px 34px;">
              <tr>
                  <td align="left" style="vertical-align: middle; padding: 10px">
                     <img height="32" width="32" style="pointer-events: none; object-fit: contain; vertical-align: middle;" src=${`${company?.avatarUrl}`} alt=${`${company?.name}`}>
                      ${company?.name}
                  </td>
                  <td width="1%" style="white-space: nowrap;">&nbsp;</td>
                  <td align="right" style="vertical-align: middle; padding: 10px">
                     <a href="#" target="_blank"><img width="72" alt="Crealo" style="vertical-align: middle;" src="https://crealo-prod-images.s3.eu-west-3.amazonaws.com/crealo-mail-logo.png" alt="Crealo"></a>
                  </td>
              </tr>
            </table>
            <div class="email-body" style="margin: 40px;">
                <div class="onboarding" style="margin-bottom: 24px;">
                    <p style="font-family: 'Poppins', sans-serif; font-size: 18px; font-weight: 400; color: #646464; margin-bottom: 0; display: table-cell; vertical-align: middle;">
                        ${translations.ThanksTo} ${company?.name}
                    </p>
                    <h1 style="font-family: 'Poppins', sans-serif; margin-top: 8px; margin-bottom: 32px; font-size: 24px;">${
                        translations.YouHaveNowAccess
                    }</h1>
                    <img style="margin-bottom: 32px;max-width:400px;display: block;" src="https://crealo-prod-images.s3.eu-west-3.amazonaws.com/crealo-mail-beneficiar-portal-screen.png" alt="">
                    ${html}
                </div>
                <div class="creds">
                      <h2>${translations.Activate}</h2>
                      <p style="font-family: 'Poppins', sans-serif; margin-top: 0px; margin-bottom: 6px; position: relative;">
                        ${
                            translations.AccountCreatedWithEmail
                        } <span style="text-decoration: none; color: black; font-weight: 500;">robert.martin@gmail.com</span>.<br/>
                        ${translations.TemporaryPassword} <br/>
                        <span style="font-weight: 500; background: #EFEFEF; border: 2px solid lightgray; border-radius: 4px; padding: 4px 8px;margin: 4px 0; display: inline-block;">XX</span> <br/>
                        <small>${translations.PasswordValidity}</small> <br/>
                      </p>
                      <div class="connection" style="margin: 24px 0;">
                          <a href="#" target="_blank" style="text-decoration: none;">
                              <div class="connect-button" style="color: white; display: table-cell; vertical-align: middle; padding: 0 16px; height: 52px; background-color: #2D2D2D; border-radius: 4px; font-family: 'Poppins', sans-serif;">
                                  <div style="text-align: center;">
                                      <img width="16" height="16" style="border-radius: 2px; vertical-align: text-top;" src="https://crealo-prod-images.s3.eu-west-3.amazonaws.com/crealo-mail-arrow-right.png" alt="">
                                      ${translations.Access}
                                  </div>
                              </div>
                          </a>
                      </div>
                    </div>
                <div style="width: 100%; max-width: 560px; height: 1px; background-color: #eaeaea; margin-top: 0; margin-bottom: 16px;"></div>
                <a class="email-footer" style="color: #646464; font-family: 'Poppins', sans-serif; text-decoration: none; font-size: 13px" href="#" target="_blank"><img src="https://crealo-prod-images.s3.eu-west-3.amazonaws.com/crealo-mail-logo.png" width="64" alt="Crealo" style="vertical-align: middle;" /> ${
                    translations.ThankTrust
                }</a>
            </div>
        </body>
    </html>
    `;

    return (
        <div className="modal-container">
            <div className="modal-wrapper">
                <Close className="close-btn" onClick={onClose} />
                <div style={{ padding: "15px" }}>
                    <H2 style={{ fontSize: "1rem" }}>Aperçu du mail :</H2>
                </div>
                <div
                    dangerouslySetInnerHTML={{ __html: beneficiarPortalOnboardingEmail }}
                    className="preview-portal-email"
                ></div>
            </div>
        </div>
    );
};

export default BeneficiaryPortalEmailPreview;
